import React from 'react';
import './MenuPage.css';

import Navigation from '../../Shared/Navigation/Navigation';
// import FindLocation from '../../PageCompos/Contact/FindLocation/FindLocation';
import Footer from '../../Shared/Footer/Footer';
import Menu from '../../PageCompos/Home/Menu/Menu';

const MenuPage = () => {
    return (
        <>
            <Navigation />
            <Menu />
            {/* <FindLocation /> */}
            <Footer />
        </>
    );
};

export default MenuPage;